// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j9-6";
export var emphasizeQuantity = "_j9-3";
export var flatBottomCorners = "_j9-5";
export var productImage = "_j9-0";
export var quantityContainer = "_j9-2";
export var tooltip = "_j9-1";
export var wrapAndEllipsesOverflow = "_j9-4";